import React, { useState } from 'react';
import { Calendar, ConfigProvider } from 'antd';
import koKR from 'antd/locale/ko_KR';
import dayjs from 'dayjs';
import { IRSchedule } from '../types';
import IRModal from './IRModal';

interface CalendarViewProps {
  irSchedules: IRSchedule[];
  selectedDate: dayjs.Dayjs;
  watchedCompanies: string[];
  isMobile: boolean;
  onDateChange: (date: dayjs.Dayjs) => void;
  onPanelChange: (date: dayjs.Dayjs) => void;
  onSelectSchedules: (schedules: IRSchedule[]) => void;
  onToggleWatch: (company: string) => void;
}

const CalendarView: React.FC<CalendarViewProps> = ({
  irSchedules,
  selectedDate,
  watchedCompanies,
  isMobile,
  onDateChange,
  onPanelChange,
  onToggleWatch,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedSchedules, setSelectedSchedules] = useState<IRSchedule[]>([]);

  const getSchedulesForDate = (date: dayjs.Dayjs) => {
    return irSchedules.filter(
      (schedule: IRSchedule) => schedule.date === date.format('YYYY-MM-DD')
    );
  };

  const dateCellRender = (date: dayjs.Dayjs) => {
    const schedules = getSchedulesForDate(date);
    if (schedules.length > 0) {
      return (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            cursor: 'pointer',
            padding: '4px',
            overflow: 'hidden',
          }}
          onClick={() => {
            setSelectedSchedules(schedules);
            setIsModalVisible(true);
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '2px',
              fontSize: '12px',
              lineHeight: '1.2',
            }}
          >
            {schedules
              .slice(0, 3)
              .map((schedule: IRSchedule, index: number) => (
                <div
                  key={index}
                  style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    backgroundColor: 'rgba(24, 144, 255, 0.1)',
                    padding: '2px 4px',
                    borderRadius: '2px',
                  }}
                >
                  <span style={{ fontWeight: 'bold' }}>{schedule.company}</span>
                  <span style={{ marginLeft: '4px' }}>{schedule.title}</span>
                </div>
              ))}
            {schedules.length > 3 && (
              <div
                style={{
                  textAlign: 'center',
                  backgroundColor: 'rgba(24, 144, 255, 0.1)',
                  padding: '2px 4px',
                  borderRadius: '2px',
                }}
              >
                +{schedules.length - 3}개 더보기
              </div>
            )}
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div style={{ marginBottom: 20 }}>
      <ConfigProvider
        locale={koKR}
        theme={{
          components: {
            Calendar: {
              fullPanelBg: '#fff',
            },
          },
        }}
      >
        <Calendar
          value={selectedDate}
          onChange={(date) => onDateChange(date)}
          dateCellRender={dateCellRender}
          onPanelChange={(date) => {
            onPanelChange(date);
          }}
        />
      </ConfigProvider>
      <IRModal
        isVisible={isModalVisible}
        schedules={selectedSchedules}
        watchedCompanies={watchedCompanies}
        isMobile={isMobile}
        onClose={() => setIsModalVisible(false)}
        onToggleWatch={onToggleWatch}
      />
    </div>
  );
};

export default CalendarView;
